import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import { connect } from 'react-redux'
import { messageActions, authActions, userActions } from '../actions'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import jwt_decode from 'jwt-decode'
import UpdatePassword from '../containers/Users/UpdatePassword'
import Media from 'react-media'
import { NavLink } from 'react-router-dom'

const styles = {
  text: {
    color: '#fff'
  },
  icon: {
    color: '#fff',
    marginRight: '6px'
  },
  button: {
    color: '#fff'
  }
}

class UserToolbar extends Component {
  state = {
    open: false,
    modalUpdatePasswordOpen: false
  }
  handleOpen = event => {
    this.props.changeUpdatePasswordForm({ newPassword: '', oldPassword: '' })
    this.setState({ anchorEl: event.currentTarget })
  }

  handleClose = callback => {
    this.setState({ anchorEl: null }, () => {
      if (typeof callback === 'function') {
        setTimeout(() => {
          callback()
        }, 350)
      }
    })
  }

  handleOpenUpdatePasswordModal = () => {
    this.setState({ modalUpdatePasswordOpen: true })
  }

  closeModalUpdatePassword = () => {
    this.setState({ modalUpdatePasswordOpen: false })
  }

  render() {
    const { classes, token } = this.props
    const { anchorEl, modalUpdatePasswordOpen } = this.state
    const { user } = jwt_decode(token)

    return (
      <div style={{ display: 'inline-block' }}>
        <Media query={'(min-width: 960px)'}>
          {(matches) =>
            matches ? (
              <Button className={classes.button} onClick={this.handleOpen}>
                <AccountCircle className={classes.icon} />
                <span className={classes.text}>{user.nome}</span>
              </Button>
            ) : null
          }
        </Media>
        <Media query={'(max-width: 959px)'}>
          {(matches) =>
            matches ? (
              <IconButton onClick={this.handleOpen}>
                <AccountCircle className={classes.icon} />
              </IconButton>
            ) : null
          }
        </Media>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={!!anchorEl}
          onClose={this.handleClose}
        >
          <MenuItem
            onClick={() => {
              this.handleClose(this.handleOpenUpdatePasswordModal)
            }}
          >
            Alterar senha
          </MenuItem>
          <NavLink to="/sair" style={{ textDecoration: 'none' }}>
            <MenuItem>Sair</MenuItem>
          </NavLink>
        </Menu>

        <UpdatePassword open={modalUpdatePasswordOpen} onClose={this.closeModalUpdatePassword} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    message: state.message.message,
    messageDuration: state.message.messageDuration,
    anchorOrigin: state.message.anchorOrigin,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    clearMessage: () => {
      dispatch(messageActions.clearMessage())
    },
    logout: () => {
      dispatch(authActions.logout())
    },
    changeUpdatePasswordForm: updatePasswordForm => {
      dispatch(userActions.changeUpdatePasswordForm(updatePasswordForm))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(UserToolbar))



// WEBPACK FOOTER //
// ./src/components/UserToolbar.js